<template>
  <div id="app">
    <img src="./assets/logo.png">
    <div style="width: 60%;">
      <component :is="introComp"></component>
      <component :is="workComp"></component>
      <hr />
      <component :is="contactComp"></component>
    </div>

  </div>
</template>

<script>
import Intro from './components/Intro'
import Contact from './components/Contact'
import Works from './components/Works'

export default {
  name: 'App',
  data () {
    return {
      introComp: 'Intro',
      workComp: 'Works',
      contactComp: 'Contact'
    }
  },
  components: {
    Intro,
    Contact,
    Works
  }
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue